let globalNotificationCallback = null;

export const setGlobalNotificationCallback = (callback) => {
    globalNotificationCallback = callback;
};

export const getGlobalNotificationCallback = () => {
    return globalNotificationCallback;
};

export const triggerNotification = (transactionId) => {
    if (globalNotificationCallback) {
        globalNotificationCallback(transactionId);
    }
};

export const handleTransactionResponse = async (response, store, generalActions) => {
    console.log('Handling transaction response:', store.getState());
    console.log(response.config);
    if (response.config && response.config.method === 'post') {
        const returnedId = response.headers['transaction-id'];
        console.log(returnedId);
        if (returnedId) {
            console.log('Before dispatch, store state:', store.getState().general);
            await store.dispatch(generalActions.setLastTransactionId(returnedId));
            console.log('After dispatch, store state:', store.getState().general);

            triggerNotification(returnedId);
        }
    }
    return response;
};
